import React from 'react';
import {noop} from 'lodash';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_EMPTY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import withRecordPopover from '../withRecordPopover';

import reportPayload from './reportPayload';
import {SeniorCoachTeamsContent} from './SeniorCoachTeamsContent';

interface SeniorCoachTeamsReportProps {
  loadingData: {total?: number};
  tt: (key: string, defaultValue?: string) => string;
  showRecordPopover: () => void;
  gqv: string | null;
}

export const SeniorCoachTeamsReport = ({
  loadingData = {},
  tt = (_key, defaultValue = '') => defaultValue,
  showRecordPopover = noop,
}: SeniorCoachTeamsReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'Senior Coach Teams')}
      description={tt(
        'description',
        'These Coaches have qualified as Senior Coach (or above) and count toward your SC team requirements for rank qualification.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={SeniorCoachTeamsContent}
    />
  );
};

export default withHOC(
  withTranslation('report.seniorCoachTeamsReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_EMPTY,
    popoverContentProps: {},
  }),
)(SeniorCoachTeamsReport);
